<template>
    <div>
        <div class="search">
            <el-autocomplete ref="ac" popper-class="calc-pop" v-model="query" :fetch-suggestions="fetch" :trigger-on-focus="true" :debounce="250"
                             :popper-append-to-body="false"
                             placeholder="Rechercher un ingrédient : carotte, lentilles, colin…"
                             aria-label="Rechercher un ingrédient" @select="onSelect">
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
                <template slot-scope="{ item }">
                    <div class="sugg">
                        <span>{{ item.label }}</span>
                        <span class="tag" :class="'tag--' + item.type_slug">{{ typeName(item.type_slug) }}</span>
                    </div>
                </template>
            </el-autocomplete>
        </div>
        <div class="filters" role="group" aria-label="Filtrer par catégorie">
            <button v-for="t in types" :key="t.slug" type="button" class="seg-btn"
                    :aria-pressed="activeType === t.id ? 'true' : 'false'"
                    @click="toggleType(t.id)">{{ t.name.replace(/-/g, ' / ') }}</button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'IngredientSearch',
    props: {
        types: {type: Array, default: () => []},
        search: {type: Function, required: true},
    },
    data() {
        return {query: '', activeType: null};
    },
    methods: {
        typeName(slug) {
            const t = this.types.find((x) => x.slug === slug);
            return t ? t.name.replace(/-/g, ' / ') : '';
        },
        // Sans filtre : 3 caractères minimum. Avec un filtre de catégorie actif : la liste de la catégorie
        // s'affiche dès le clic, même champ vide (comportement de la maquette).
        fetch(q, cb) {
            const query = q || '';
            if (!this.activeType && query.length < 3) { cb([]); return; }
            this.search(query, this.activeType).then((list) => cb(list || [])).catch(() => cb([]));
        },
        toggleType(id) {
            this.activeType = this.activeType === id ? null : id;
            const ac = this.$refs.ac;
            if (!ac) return;
            ac.focus();
            // focus() ne relance pas la recherche si le champ est déjà actif (Safari ne déplace pas le focus sur un bouton)
            ac.getData(this.query);
        },
        onSelect(item) {
            this.query = '';
            this.activeType = null;
            this.$emit('select', item);
        },
    },
};
</script>
